export const collapseContainerConfig = {
  base: 'flex mt-1 w-full mb-3',
  open: 'justify-end pr-3',
  closed: 'justify-center',
}
